import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  IconButton,
  Popover,
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import DateRangePickerComponent from '../KeyAnalytics/DateRangePickerComponent';
import useFetchData from '../Hooks/useFetchData';
import { formatDateRange } from '../Hooks/dateUtils';
import './EmployeeComponents.css';

export default function HospitalF2FCallsComponent({ employeeName }) {
  const [dateRange, setDateRange] = useState(['10-01-2025', '12-31-2025']);
  const [anchorEl, setAnchorEl] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;
  const endPoint = '/api/activity_hospital_f2f_calls';
  const { stats, loading, fetchData } = useFetchData(apiUrl, endPoint);

  useEffect(() => {
    if (!employeeName) return;
    const [from_date, to_date] = dateRange;
    fetchData({ employee_name: employeeName, from_date, to_date });
  }, [employeeName, dateRange]);

  const handleFilterClick = e => setAnchorEl(e.currentTarget);
  const handleFilterClose = () => setAnchorEl(null);

  const handleApply = filters => {
    setDateRange([filters.from_date, filters.to_date]);
    handleFilterClose();
  };

  const handleReset = () => {
    setDateRange([null, null]);
    handleFilterClose();
  };

  const open = Boolean(anchorEl);
  const id = open ? 'popover-hospital' : undefined;
  const formattedRange = formatDateRange(dateRange);

  return (
    <>
      <Tooltip title="Hospital F2F Calls" arrow>
        <Card className="employee-card">
          <CardContent>
            <Box className="employee-header">
              <Typography variant="h6" className="employee-title">
                Hospital F2F Calls
              </Typography>
              <IconButton size="small" onClick={handleFilterClick} className="employee-icon-button">
                <FilterListIcon />
              </IconButton>
            </Box>

            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                <CircularProgress />
              </Box>
            ) : (
              <Table size="small">
                <TableHead>
                  <TableRow className="employee-table-head">
                    <TableCell>Month</TableCell>
                    <TableCell align="right">Avg/Day</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {stats.total_hospital_f2f_calls?.map((row, i) => (
                    <TableRow key={i} className="employee-table-row">
                      <TableCell>{row.month}</TableCell>
                      <TableCell align="right">
                        {row.calls != null
                          ? row.calls.toLocaleString()
                          : '0'}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}

            <Typography variant="body2" className="employee-date-range">
              {formattedRange}
            </Typography>
          </CardContent>
        </Card>
      </Tooltip>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleFilterClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ className: 'employee-popover' }}
      >
        <Box sx={{ p: 2, width: 300 }}>
          <DateRangePickerComponent
            dateRange={dateRange}
            setDateRange={setDateRange}
            onApply={handleApply}
            onReset={handleReset}
          />
        </Box>
      </Popover>
    </>
  );
}